import { View, Text, StyleSheet } from 'react-native'
import { router } from 'expo-router'
import { Like } from '@/src/assets/icons/Like'
import { useDisableSwipingBackToThePreviousPage } from '@/src/common/hooks/disableSwipingBackToThePreviousPage'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { DesignSystem } from '@/src/design-system'
import { mesaColorNames, typography } from '@/src/common/theme'
import { Button } from '@/src/common/components/Button'
import * as Stores from '../stores'
import * as Navigation from '../navigation'

export function TransferSuccessScreen() {
  const { mesaPointsToRedeem, partnerCredits, remainingPoints } = Stores.usePointsToOmniStore()

  useDisableSwipingBackToThePreviousPage()
  // Survey trigger commented out until added to survey system
  // Surveys.Hooks.useScreenUnmountTrigger('rewards_partner_transfer_success')

  const conversionText =
    mesaPointsToRedeem && partnerCredits
      ? `${mesaPointsToRedeem.toLocaleString()} Mesa Points = ${partnerCredits.toLocaleString()} Omni Credits`
      : '30,000 Mesa Points = 100 Omni Credits'

  return (
    <StandaloneWrapper
      screen={Navigation.Routes.TransferSuccess.route}
      title="Points Transfer Confirmation"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
      onBackPress={() => router.dismissTo('/main/rewards')}
      contentContainerStyle={{ maxWidth: 600, width: '100%' }}
    >
      <View style={styles.successContainer}>
        <View style={styles.successIcon}>
          <Like />
        </View>
        <Text style={[typography['heading/heading3'], styles.successText]}>
          Mesa Points successfully transferred
        </Text>
      </View>

      <DesignSystem.Card style={styles.summaryCard}>
        <View style={[styles.infoSection, styles.infoSectionBorder]}>
          <Text style={styles.infoHeader}>Transfer To</Text>
          <Text style={typography['label/md-bold']}>Omni Hotel & Resorts</Text>
        </View>

        <View style={[styles.infoSection, styles.infoSectionBorder]}>
          <Text style={styles.infoHeader}>Conversion Amount</Text>
          <Text style={typography['label/md-bold']}>
            {mesaPointsToRedeem?.toLocaleString() ?? '0'} Points
          </Text>
        </View>

        <View style={[styles.infoSection, styles.infoSectionBorder]}>
          <Text style={styles.infoHeader}>Conversion Rate</Text>
          <Text style={typography['label/md-bold']}>{conversionText}</Text>
        </View>

        <View style={styles.infoSection}>
          <Text style={styles.infoHeader}>Remaining Mesa Points</Text>
          <Text style={typography['label/md-bold']}>
            {remainingPoints?.toLocaleString() ?? '0'}
          </Text>
        </View>
      </DesignSystem.Card>

      <Button
        onPress={() => router.dismissTo('/main/rewards')}
        title="Return Home"
        style={{ marginBottom: 40 }}
      />
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  successContainer: {
    gap: 16,
    alignItems: 'center',
    paddingVertical: 20,
  },
  successIcon: {
    backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
    borderRadius: 48,
    padding: 16,
    alignItems: 'center',
  },
  successText: {
    color: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    textAlign: 'center',
  },
  summaryCard: {
    borderRadius: 12,
    padding: 16,
    gap: 16,
  },
  infoSection: {
    gap: 8,
    padding: 4,
  },
  infoSectionBorder: {
    borderBottomWidth: 1,
    borderBottomColor: mesaColorNames['semantic/bg/disabled #DADDDE'],
    paddingBottom: 16,
  },
  infoHeader: {
    ...typography['label/sm-regular'],
    color: mesaColorNames['Greyscale/500 #6E7375'],
  },
})
